"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = watchers;
exports.getPaymentOrderstatus = getPaymentOrderstatus;
exports.initiatePayment = initiatePayment;
exports.updatePaymentSagas = updatePaymentSagas;
var _effects = require("redux-saga/effects");
var _sagas = require("../../../astercore/auth/login/redux/sagas");
var api = _interopRequireWildcard(require("../api/api"));
var actions = _interopRequireWildcard(require("./actions"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function* blockSlot(params) {
  try {
    yield (0, _effects.put)(actions.BLOCK_SLOT_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.blockSlot, params.data.params, tokenData);
    yield (0, _effects.put)(actions.BLOCK_SLOT_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.BLOCK_SLOT_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* getBookingDetail(params) {
  try {
    yield (0, _effects.put)(actions.GET_BOOKING_DETAIL_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getBookingDetail, params.data.params.id, tokenData);
    yield (0, _effects.put)(actions.GET_BOOKING_DETAIL_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_BOOKING_DETAIL_API.failure(err));
  }
}
function* confirmSlot(params) {
  try {
    yield (0, _effects.put)(actions.CONFIRM_SLOT_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.confirmSlot, params.data.params, tokenData);
    yield (0, _effects.put)(actions.CONFIRM_SLOT_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.CONFIRM_SLOT_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* updateBooking(params) {
  try {
    yield (0, _effects.put)(actions.UPDATE_BOOKING_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.updateBooking, params.data.params, tokenData);
    yield (0, _effects.put)(actions.UPDATE_BOOKING_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.UPDATE_BOOKING_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* initiatePayment(requestParams) {
  try {
    yield (0, _effects.put)(actions.INITIATE_HOMECARE_PAYMENT_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.initiatePayment, requestParams, tokenData);
    yield (0, _effects.put)(actions.INITIATE_HOMECARE_PAYMENT_API.success(mainResponse));
    requestParams.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.INITIATE_HOMECARE_PAYMENT_API.failure(err));
    requestParams.data.onFailure(err);
  }
}
function* getPaymentOrderstatus(params) {
  try {
    yield (0, _effects.put)(actions.GET_HOMECARE_PAYMENT_STATUS_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getPaymentOrderstatus, params, tokenData);
    yield (0, _effects.put)(actions.GET_HOMECARE_PAYMENT_STATUS_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_HOMECARE_PAYMENT_STATUS_API.failure(err));
    params.data.onFailure(err);
  }
}
function* rescheduleBooking(params) {
  try {
    yield (0, _effects.put)(actions.RESCHEDULE_BOOKING_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.rescheduleBooking, params.data.params, tokenData);
    yield (0, _effects.put)(actions.RESCHEDULE_BOOKING_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.RESCHEDULE_BOOKING_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* updatePaymentSagas(params) {
  try {
    yield (0, _effects.put)(actions.UPDATE_PAYMENT_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.updatePaymentApi, params.data.params, tokenData);
    yield (0, _effects.put)(actions.UPDATE_PAYMENT_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.UPDATE_PAYMENT_API.failure(err));
    params.data.onFailure(err);
  }
}
function* watchers() {
  yield (0, _effects.takeLatest)(actions.BLOCK_SLOT, blockSlot);
  yield (0, _effects.takeEvery)(actions.GET_BOOKING_DETAIL, getBookingDetail);
  yield (0, _effects.takeLatest)(actions.CONFIRM_SLOT, confirmSlot);
  yield (0, _effects.takeLatest)(actions.UPDATE_BOOKING, updateBooking);
  yield (0, _effects.takeLatest)(actions.INITIATE_HOMECARE_PAYMENT, initiatePayment);
  yield (0, _effects.takeLatest)(actions.GET_HOMECARE_PAYMENT_STATUS, getPaymentOrderstatus);
  yield (0, _effects.takeEvery)(actions.RESCHEDULE_BOOKING, rescheduleBooking);
  yield (0, _effects.takeLatest)(actions.UPDATE_PAYMENT, updatePaymentSagas);
}